import { Reorder } from 'framer-motion';
import pluralize from 'pluralize';
import classNames from 'classnames';

import PlusCircle from '@/components/Icons/PlusCircle';
import ExpandableListItem from './ExpandableListItem';
import s from './ExpandableList.module.scss';
import itemStyles from './ExpandableListItem.module.scss';

type ExpandableListProps<T> = {
  items: T[];
  headerIcon: JSX.Element;
  label: string;
  currentSelectedItem?: string | null;
  initOpen?: boolean;
  onReorderItems?: (items: T[]) => void;
  onAddItem: () => void;
  onSelectItem: (item: T) => void;
};

const ExpandableList = <T extends {
  id: string; label: string; conditionExpression?: unknown | null
}>(props: ExpandableListProps<T>): React.ReactElement => {
  const { items, label, currentSelectedItem, onReorderItems, onAddItem, onSelectItem } = props;

  return (
    <div className={s.listContainer}>
      <h2 className={s.heading}>{pluralize(label, 2)}</h2>
      {typeof onReorderItems === 'function'
        ? (
          <Reorder.Group as="div" axis="y" values={items} className={s.listContent} onReorder={onReorderItems}>
            {items.map(item => (
              <ExpandableListItem key={item.id} item={item} isSelected={item.id === currentSelectedItem} onClick={() => onSelectItem(item)} />
            ))}
          </Reorder.Group>
        )
        : (
          <div className={s.listContent}>
            {items.map(item => (
              <button
                key={item.id}
                className={itemStyles.listItem}
                onClick={() => onSelectItem(item)}
              >
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        )}

      <button className={classNames(s.addListItemButton)} onClick={onAddItem}>
        <PlusCircle weight="fill" /> {`Add ${pluralize(label, 1)}`}
      </button>
    </div>
  );
};

export default ExpandableList;
